import React from 'react';

import PropTypes from 'prop-types';

import { ListItem, ListItemIcon } from '@mui/material';

import { COLORS } from '../Constant/COLORS';

import { TypoPoppBlue } from './Typo';
import { CircleBox, TypoMiddle } from './CustomListItemsComponents';

const CustomListItem2 = ({ children, index, ...rest }) => {
  return (
    <ListItem {...rest}>
      <ListItemIcon>
        <CircleBox border={`1px solid ${COLORS.blue}`}>
          <TypoMiddle color={COLORS.blue}>{index}</TypoMiddle>
        </CircleBox>
      </ListItemIcon>
      <TypoPoppBlue>{children}</TypoPoppBlue>
    </ListItem>
  );
};

CustomListItem2.propTypes = {
  rest: PropTypes.object,
  children: PropTypes.string,
  index: PropTypes.string,
};

export default CustomListItem2;
